'use strict';
require('../../../modules/es.array.concat');
var getBuiltInPrototypeMethod = require('../../../internals/get-built-in-prototype-method');

module.exports = getBuiltInPrototypeMethod('Array', 'concat');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/concat.js
// module id = 298
// module chunks = 0 1 2 3